import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", email: "", phone: "", business_name: "", message: "" };
const FIELDS = [
  ["name", "Full name", "text", true],
  ["phone", "Phone / WhatsApp", "tel", true],
  ["email", "Email", "email", true],
  ["business_name", "Business name", "text", false],
];

export const ConnectOwnerForm = ({ circle }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/circles/${circle.slug}/connect`, form);
      setDone(true);
      toast.success("Message sent to the region owner.");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="connect-owner-success" className="py-14 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-navy flex items-center justify-center mb-5"><Check size={24} className="text-white" /></div>
        <h3 className="font-display text-2xl text-navy">Thanks, {form.name.split(" ")[0]}.</h3>
        <p className="mt-2 text-gray-600">The {circle.city} owner will be in touch soon.</p>
      </div>
    );
  }

  return (
    <form data-testid="connect-owner-form" onSubmit={onSubmit} className="space-y-4">
      <h3 className="font-display text-2xl text-navy">Connect with the owner</h3>
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, type, required]) => (
          <div key={k}>
            <Label htmlFor={`co-${k}`}>{label}{required ? " *" : ""}</Label>
            <Input id={`co-${k}`} type={type} required={required} value={form[k]} onChange={update(k)} data-testid={`connect-owner-input-${k}`} className="mt-1.5 h-11 bg-white" />
          </div>
        ))}
      </div>
      <div>
        <Label htmlFor="co-message">How can they help?</Label>
        <Textarea id="co-message" rows={4} maxLength={2000} value={form.message} onChange={update("message")} data-testid="connect-owner-input-message" className="mt-1.5 bg-white" placeholder="e.g. I'd like to visit a meeting, or learn about membership" />
      </div>
      <button type="submit" disabled={busy} data-testid="connect-owner-submit" className="w-full inline-flex items-center justify-center gap-2 bg-navy text-white font-semibold py-4 rounded-full hover:bg-navy-deep hover:-translate-y-0.5 transition disabled:opacity-60">
        {busy && <Loader2 size={16} className="animate-spin" />}Send message
      </button>
    </form>
  );
};
